import React, { Component } from 'react';
import '../ppUtilities.js';
import Card from './Card';
import CardIcon from './CardIcon.js';
import CardContent from './CardContent.js';
import CardHeader from './CardHeader.js';
import CardSummary from './CardSummary.js';
import CardDetails from './CardDetails.js';
import CardDetailsToggle from './CardDetailsToggle.js';
import CardActions from './CardActions.js';
import ProductPill from './ProductPill.js';
import ProductSummaryList from './ProductSummaryList.js';
import CompareButton from './CompareButton.js';
import ViewCompareButton from './ViewCompareButton.js';
import ProductDescription from './ProductDescription.js';
import ProductToggleGroup from './ProductToggleGroup.js';
import ProductToggleInfo from './ProductToggleInfo.js';
import QuantityPicker from './QuantityPicker.js';
import ProductPrice from './ProductPrice.js';
import AddToCartButton from './AddToCartButton.js';
import AddToCartMessage from './AddToCartMessage.js';
import UnavailableItemButton from './UnavailableItemButton.js';
import AuthButton from './AuthButton.js';
import withProductHelpers from './withProductHelpers.js';

class ProductCard extends Component {
	constructor(props) {
		super(props);
		this.aemProdInfo = this.props.getAEMProductInfo(this.props.currSecKey);
	}

	render() {
		let product = this.props.product;
		let price = this.props.price;
		let prodQty = product.qty;
		let kindClass = this.props.kind === 'single' ? 'card' : '';
		let animationClass = this.props.hasAnimation ? 'will-animate' : '';
		let showPrice = price ? 'prc__hide-price' : '';

		let activeProduct = product.products.length ? product.products.filter((prod) => product.activeSku === prod.sku)[0] : '';
		let isNoAddCardProd = product.products.length && product.products[0].noPriceLabel !== null;
		const maxQty = product?.products?.length ? Math.min(product.products.map((product) => product.qtyTo)) : null;
		const isFreeProd = activeProduct.isFree === 'true';
		const hasPriceDisplayRestrictions = !isFreeProd && this.props.errorType;
		let cardIdentifier = this.props.getCardIdentifier(product.title); // Important: cards will target this.
		let updateNo = this.props.updateNo ? `updateNo-${this.props.updateNo}` : '';

		return (
			<Card id={cardIdentifier} cardId={this.props.cardIdList?.join('')} className={`${kindClass} ${animationClass} ${updateNo}`}>
				<CardIcon icon={product.icon} alt={product.title} height={this.props.isVertical ? '48' : '58'} width={this.props.isVertical ? '48' : '58'} />
				<CardContent>
					<CardHeader title={product.title}>{/*<ProductPill tag={product.tag} modalIdentifier={product.modalIdentifier} />*/}</CardHeader>
					<CardSummary>
						<ProductSummaryList bullets={product.bullets} />
						<div className="prc__card--cta">
							<ProductToggleGroup
								products={product.products}
								activeSku={product?.activeSku}
								formattedLocale={this.props.formattedLocale}
								currency={this.props.currency}
								onToggleClick={this.props.handlePriceChangeProxy}
							/>
							{!this.props.errorType && <ProductToggleInfo products={product.products} />}
						</div>
					</CardSummary>
					<CardDetails>
						<div className="prc__desc hideonvertical">
							<div className="prc__desc--actions">
								<CardDetailsToggle active={!this.props.isOpen} ariaText={product.title} onClick={this.props.handleViewDesc} />
								{this.props.hasComparisonData && (
									<>
										<CompareButton onClick={this.props.handleProdCompareProxy} />
										<ViewCompareButton hidden={!product.compare} onClick={() => this.props.handleScrollTo(product.ctID, { offset: -56 })} />
									</>
								)}
							</div>
							<ProductDescription
								hidden={!this.props.isOpen}
								longDescription={product.longDescription}
								ariaText={product.title}
								systemRequirementUrl={product.systemRequirementUrl}
								languageSupportedUrl={product.languageSupportedUrl}
								whatsIncluded={product.whatsIncluded}
							/>
						</div>
						<div className="prc__desc showonvertical">
							<ProductDescription
								hidden={false}
								longDescription={product.longDescription}
								ariaText={product.title}
								systemRequirementUrl={product.systemRequirementUrl}
								languageSupportedUrl={product.languageSupportedUrl}
							/>
						</div>
					</CardDetails>
				</CardContent>
				{!hasPriceDisplayRestrictions ? (
					<CardActions>
						<div className={`prc__pricing-controls ${!activeProduct.isPurchasable ? 'hide' : ''}`}>
							{maxQty !== 1 && (
								<QuantityPicker
									onDecrement={this.props.handleQtyMinusProxy}
									onIncrement={this.props.handleQtyPlusProxy}
									onChange={this.props.handleQtyChangeProxy}
									qty={prodQty}
									error={product.inputError.error}
									onRemoveError={this.props.handleRemoveErrorMsgProxy}
								/>
							)}
							<ProductPrice
								activePrice={product.activePrice}
								renewalTitle={activeProduct.renewalTitle}
								formattedLocale={this.props.formattedLocale}
								currency={this.props.currency}
							/>
						</div>
						<AddToCartButton
							onClick={this.props.handleAddToCartProxy}
							ariaText={product.title}
							disabled={product.qty === 0 || product.cartCallActive === true}
							className={`${showPrice} ${!activeProduct.isPurchasable || (activeProduct.isPurchasable && isNoAddCardProd) ? 'hide' : ''}`}
							label={this.aemProdInfo.addToCart}
						/>
						<AddToCartMessage animateOn={product.cartQty.update} qty={product?.cartQty?.qty} />
						{(!activeProduct.isPurchasable || (activeProduct.isPurchasable && isNoAddCardProd)) && (
							<UnavailableItemButton
								className={isNoAddCardProd ? 'has-price' : ''}
								label={(activeProduct.isFree === 'true' || isNoAddCardProd) ? activeProduct.noPriceLabel : null}
								url={activeProduct.noPriceLink}
							/>
						)}
					</CardActions>
				) : (
					<CardActions>
						<div className="prc__pricing-controls"></div>
						<div className="prc__show-no-pricing">
							<AuthButton aemProdInfo={this.aemProdInfo} errorType={this.props.errorType} />
						</div>
					</CardActions>
				)}
			</Card>
		);
	}
}

export default withProductHelpers(ProductCard);
